import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import * as bootstrap from 'bootstrap';
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap-icons/font/bootstrap-icons.min.css"
import'./config/axios';

const app = createApp(App);
app.provide('bootstrap', bootstrap);


app.use(router).use(i18n).mount('#app')
